export enum QualtricsParams {
    HPProductsPlanned = 'hp_product_planned',
    PVProductsPlanned = 'pv_product_planned',
    QuoteAdded = 'quote_added'
}
